import { createRouter, createWebHistory } from 'vue-router'
//import HomeView from '../views/HomeView.vue'
import RefDestinations from '../components/RefDestinations.vue';
import RefExpense from '../components/RefExpense.vue';
import RefSource from '../components/RefSource.vue';
import RefAnimal from '../components/RefAnimal.vue';
import MovementManager from '../components/MovementManager.vue';
import MovementES from '../components/MovementES.vue'
import ListOfMovement from '../components/ListOfMovement.vue'
import LoginApp from '../views/LoginApp.vue'
import MonthlyExpenseManager from '../components/MonthlyExpenseManager.vue'
import YearlyExpenses from '../components/YearlyExpenses.vue'
import Dashboard from '../components/DashboardApp.vue'
import ListOfDetailMovement from '../components/ListOfDetailMovement.vue'
import LivestockRecord from '../components/LivestockRecord.vue'
import LogsInfo from '../components/LogsInfo.vue'
import Profile from '../views/ProfileView.vue'
import RegisterView from '../views/RegisterView.vue'
import UserManagement from '../views/UserManagement.vue';
import MovementOut from '../components/MovementOut.vue';

const routes = [
  { path: '/', name: 'dashboard', component: Dashboard, meta: { requiresAuth: true } },
  { path: '/login', name: 'Login', component: LoginApp },
  { path: '/destinations', component: RefDestinations, meta: { requiresAuth: true } },
  { path: '/expenses', component: RefExpense, meta: { requiresAuth: true } },
  { path: '/sources', component: RefSource, meta: { requiresAuth: true } },
  { path: '/animals', component: RefAnimal, meta: { requiresAuth: true } },
  { path: '/incoming', component: MovementManager, meta: { requiresAuth: true } },
  { path: '/outgoing', component: MovementManager, meta: { requiresAuth: true } },
  { path: '/MovementES', component: MovementES, meta: { requiresAuth: true } },
  { path: '/ListOfMovement', component: ListOfMovement, meta: { requiresAuth: true } },
  { path: '/MonthlyExpense', component: MonthlyExpenseManager, meta: { requiresAuth: true } },
  { path: '/YearlyExpenses', component: YearlyExpenses, meta: { requiresAuth: true } },
  { path: '/ListOfDetailMovement', component: ListOfDetailMovement, meta: { requiresAuth: true } },
  { path: '/livestock-record', component: LivestockRecord, meta: { requiresAuth: true } },
  { path: '/logs', component: LogsInfo, meta: { requiresAuth: true } },
  { path: '/profile', component: Profile, meta: { requiresAuth: true } },
  { path: '/register', component: RegisterView, meta: { requiresAuth: true } },
  { path: '/user-management', component: UserManagement, meta: { requiresAuth: true } },
  { path: '/MovementOut', component: MovementOut, meta: { requiresAuth: true } },
  
]

const router = createRouter({
  history: createWebHistory(), //process.env.BASE_URL),
  routes
})

// Navigation guard to check for token presence
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !localStorage.getItem('authToken')) {
    next({ name: 'Login' });
  } else {
    next();
  }
});

export default router
